import React from 'react'
import SignupCreds from '../Modules/SignupModule/SignupCreds'
import Header from '../Modules/Components/Header'
import Footer from '../Modules/Components/Footer'

const Signup = () => {
  return (
    <>
    <Header/>
    <SignupCreds/>
    <Footer/>
    </>
  )
}

export default Signup